import React, { useEffect } from "react";
import "./AccessDeniedLocks.css";

export default function AccessDeniedLocks() {
  useEffect(() => {
    const interval = 500;

    function generateLocks() {
      const lock = document.createElement("div");
      const [top, left] = generatePosition();
      lock.innerHTML = '<div class="adlocks-top"></div><div class="adlocks-bottom"></div>';
      lock.style.top = top;
      lock.style.left = left;
      lock.className = "adlocks-lock";
      document.querySelector(".adlocks-wrapper").appendChild(lock);

      setTimeout(() => {
        lock.style.opacity = "1";
        lock.classList.add("adlocks-generated");
      }, 100);

      setTimeout(() => {
        lock.remove();
      }, 2000);
    }

    function generatePosition() {
      const x = Math.round(Math.random() * 100) + "%";
      const y = Math.round(Math.random() * 100) + "%";
      return [x, y];
    }

    const lockInterval = setInterval(generateLocks, interval);
    generateLocks();

    return () => clearInterval(lockInterval);
  }, []);

  return (
    <div className="adlocks-wrapper">
      <div className="adlocks-container">
        <h1>
            403
        </h1>
        <p>اجازۀ دسترسی به این صفحه را ندارید!</p>
      </div>
    </div>
  );
}

